var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-documentation-layout',{attrs:{"heading":_vm.heading,"desc":_vm.$vuetify.lang.t(_vm.desc)}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers.map(function (x) {
        return {
          text: _vm.$vuetify.lang.t(x.text),
          sortable: x.sortable,
          value: x.value
        };
      }),"items":_vm.options,"items-per-page":-1,"search":_vm.search}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }